export default __webpack_public_path__ + "722d015da23f54616007154e74fc4817.png";